const formatMarkdownText = (text) => {
  return text ? text.replace(/\\n/g, "\n") : text;
};

export default formatMarkdownText;
